import React, { FC } from 'react'
import { Box, Button } from '@dasa-health/components-react'
import { BrandMapping, Images } from '@nsw-paginas-deslogadas/assets'
import { BrandId } from '@nsw-paginas-deslogadas/constants'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import Topic, { TopicItemProps } from './../Topic'
import * as S from './styles'
import { LinkInline } from '@dasa-health/alma-react'

const FoldPagePresentationBrand: FC = () => {
    const { PersonAnalysingWithoutMask } = Images
    const { brand: brand_ } = useAppContext()
    const brand = BrandMapping[brand_.mappingId]
    const isNav = brand_.mappingId === BrandId.Nav

    const items: TopicItemProps[] = [
        {
            icon: 'Clock',
            text: `Agendando seus exames ${brand.vaccine ? 'e vacinas' : ''} online, você é atendido mais rapidamente.`,
            title: 'Atendimento rápido',
        },
        {
            icon: 'Calendar',
            text: 'Escolha local, data e horário que melhor se encaixam na sua rotina.',
            title: 'Liberdade de agendamento',
        },
        {
            icon: 'Information',
            text: 'Acompanhe seus agendamentos, de onde estiver e cancele quando precisar.',
            title: 'Acompanhamento',
        },
    ]

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'Main Hero',
        'data-current-service': 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <>
            <S.Container data-testid="page-presentation-testID">
                <S.PrincipalBox columns={[2]} gap={2}>
                    <S.BoxTexts>
                        <S.Title>
                            {`Agendamento online de exames ${brand.vaccine ? 'e vacinas ' : ''}`}
                            {`${!isNav ? `no ${brand.name}` : ''} `}
                        </S.Title>
                        <S.SubTitle>
                            {`Agende seus exames ${brand.vaccine ? 'e vacinas' : ''} comigo, `}
                            {`${isNav ? `sua plataforma de saúde digital!` : ''} `}
                            {`${!isNav ? `plataforma de saúde digital do ${brand.name} e sua também.` : ''} `}
                        </S.SubTitle>
                    </S.BoxTexts>

                    <Box>
                        <S.Img alt={PersonAnalysingWithoutMask.alt} src={PersonAnalysingWithoutMask.src} />
                    </Box>
                </S.PrincipalBox>
                <S.ButtonsBox>
                    {brand.vaccine && (
                        <LinkInline
                            href={brand.buttons.mainFold.vaccines}
                            sx={{ textDecoration: 'none' }}
                            target="_self"
                            {...dataAtributtes('Agendar vacinas')}
                        >
                            <Button data-testid="btn-vaccines">Agendar vacina</Button>
                        </LinkInline>
                    )}
                    <LinkInline
                        href={brand.buttons.mainFold.exams}
                        sx={{ textDecoration: 'none' }}
                        target="_self"
                        {...dataAtributtes('Agendar exames')}
                    >
                        <Button data-testid="btn-exams">Agendar exame</Button>
                    </LinkInline>
                </S.ButtonsBox>

                <S.TopicBox>
                    <Topic.Group items={items} />
                </S.TopicBox>
            </S.Container>
        </>
    )
}

export default FoldPagePresentationBrand
